import SyntaxHighlighter from './SyntaxHighlighter.view';

export default SyntaxHighlighter;
